import React, { useState } from "react"
import { UpgradeGuestMembershipActionPopupCss } from "./UpgradeGuestMembershipStyled"
import SuccessGreenTick from "web/assets/images/success-green-tick.png";
import { useDispatch } from "react-redux";
import { toggleGuestUpgradeModal } from "redux/actions/app";
import { useHistory } from "react-router-dom";

const UpgradeGuestMembership = () => {

  const dispatch = useDispatch()
  let history = useHistory();
  const accountType = localStorage.getItem('accountType')
  const approvalStatus = localStorage.getItem('approvalStatus')
  return (
    <>
      {/* Upgrade Membership Action Modal popup*/}
      <UpgradeGuestMembershipActionPopupCss>
        <img
          className="success-green-tick"
          src={SuccessGreenTick}
          alt="SuccessGreenTick"
          width={"100px"}
        />
        <h4>Become a Member Today</h4>
        <ul>
          <li>- Lower platform fees</li>
          <li>- ACH payments</li>
          <li>- Ability to post</li>
          <li>- Build private groups</li>
        </ul>
        <button
          className="upgrade-btn"
          onClick={() => {
            if(accountType === "Guest" && approvalStatus === "REQUEST_FOR_APPROVAL"){
              dispatch(toggleGuestUpgradeModal(true))
            }else{
              // dispatch(toggleGuestUpgradeModal(true))
              localStorage.setItem('guestUser', false);
              localStorage.setItem('postInventory', true);
              localStorage.setItem('memberShipType', 'buyerSeller');
              localStorage.setItem('guestUserUpgrade', true);
              history.push("/registration");
            }
          }}>Upgrade for $0</button>
      </UpgradeGuestMembershipActionPopupCss>
    </>
  )
}

export default UpgradeGuestMembership